import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { GridColumnMeta } from "../../ant-grid-custom/ant-grid-custom-model";
import { ResearchGridDataService } from "../research-grid-data.service";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { ActivatedRoute } from "@angular/router";
import { GetResearchDocsParams } from "src/app/store/models/research-grid-page.model";
import {
  ChangeFilter,
  SetResearchBase,
  ResetFilter,
} from "src/app/store/actions/research-grid-page.actions";
import { Dictionary } from "src/app/store/models/common_types";
import { Subject } from "rxjs";
import { AppService } from "src/app/app.service";
import {
  VAIconRegistryService,
  download,
  infoCircle,
  redo,
} from "@va/core-library/icons";

@Component({
  selector: "app-research-grid",
  templateUrl: "./research-grid-page.component.html",
  styleUrls: ["./research-grid-page.component.scss"],
  host: { class: "research-page-component" },
  encapsulation: ViewEncapsulation.None,
})
export class ResearchGridPageComponent implements OnInit {
  onResetSubject: Subject<void> = new Subject<void>();
  checkRowsSubject: Subject<Array<string>> = new Subject<Array<string>>();
  legacyUrl = `${window.caUrl}/app`;
  columnsData: GridColumnMeta[][];
  columnFields: any[];
  dataToUse: {};
  processedData: any[];
  dataSet = false;
  hasError = false;
  faSpinner = faSpinner;
  errorMsg = "";
  ticker = "";
  companySymbologyId: number;
  isPrimayTicker = true;
  currentGridFilter: any;
  selectedRows: Array<any> = [];
  analystDataSet = false;
  resetSelection = false;
  analystData = {
    headerText: "Analyst",
    list: [],
  };
  brokerDataSet = false;
  brokerData = {
    headerText: "Broker",
    list: [],
  };
  brokerMapping = {};
  totalResultCount = 0;
  loadingDocuments = false;
  selectedDownloadItems: {};
  vaCompanyId = "";
  isFirstLoad = true;
  constructor(
    private service: ResearchGridDataService,
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.columnFields = [
      {
        field: "publicationDate",
        renderer: "date",
      },
      {
        field: "analysts",
        renderer: "analyst",
      },
      {
        field: "publisher",
        renderer: "link",
      },
      {
        field: "title",
        renderer: "link",
      },
      {
        field: "pageCount",
        renderer: null,
      },
      {
        field: "downloadable",
        renderer: "download",
      },
      {
        field: "printable",
        renderer: "print",
      },
    ];
    this.columnsData = [
      [
        {
          children: 1,
          header: "Date Published",
          sortKey: "publication_date",
          showSort: true,
          showFilter: false,
        },
        {
          children: 1,
          header: "Analyst",
          sortKey: "analysts.email",
          showSort: false,
          showFilter: false,
        },
        {
          children: 1,
          header: "Broker",
          sortKey: "publisher.id",
          showSort: true,
          showFilter: false,
        },
        {
          children: 1,
          header: "Title",
          sortKey: "title",
          showSort: false,
          showFilter: false,
        },
        {
          children: 1,
          header: "Pages",
          sortKey: "page_count",
          showSort: false,
          showFilter: false,
        },
        {
          children: 1,
          header: "",
          sortKey: "icon1",
          showSort: false,
          showFilter: false,
        },
        {
          children: 1,
          header: "",
          sortKey: "icon2",
          showSort: false,
          showFilter: false,
        },
      ],
    ];
    this.ticker = this.activatedRoute.snapshot.paramMap.get("ticker");
    this.companySymbologyId = Number(
      this.activatedRoute.snapshot.paramMap.get("companySymbologyId"),
    );
    this.iconRegistry.registerIcons([download, redo, infoCircle]);
  }

  ngOnInit() {
    this.service.getResearchBaseUrl(this.ticker).subscribe(
      (response) => {
        if (response.status === "error") {
          this.hasError = true;
          this.errorMsg = "Sorry, something went wrong.";
          throw Error("getResearchBaseUrl throws status error");
        }
        if (response.data.research_page_access === false) {
          this.hasError = true;
          this.errorMsg =
            "Please contact your account manager for research activation.";
          throw Error("not entitled");
        }
        this.vaCompanyId = response.data.company_id;
        const filters = {
          companyId: [this.companySymbologyId],
          primaryCo: this.isPrimayTicker ? 1 : 0,
          page: 1,
          pageSize: 50,
        };
        this.brokerMapping = response.oa_va_source_firm_mapping;
        // const jwt =
        //   "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiIxMzZ-fjIwMjAtMDEtMjF-fjE1ODE5NjQyMzEuMCIsInVzZXIiOiJwcmFuYXYubmFuamFwcGFAdmlzaWJsZWFscGhhLmNvbSIsImV4cCI6MTU4NDUzNDYzMS4wfQ.TFJcCBjMulN7puVyGRJNphlXLehCaiim64gXUuBZc5F6pcX31scBSJCVoRXsx0TCh3a8zG3EqltZSmN-FyiUkxrlaLk0V7vQaYU_ILgFxMynUKOyE6XZ5j2VbIgWr-IlSakDL615dfdU3owbJ0k-cbDLzjWe5gsEBAd4wyLKhzAtUgwIzRaXtWqsVWrJcVBRZA_TL01iRd5A0Hy2VjCeimuuACIAUDWjrn4p2d64CjuO098oRx6knuvGJP4HpFRUlvOBKg-rprSim-OBvBkhmRQBgJFSTqpE9QnxejegcC_bcUD0Lqx6PTZDFEphQxv7Dj-vfxrEmMLvz3c1c2m5uQ";
        const payload = {
          gridFilters: filters,
        };

        this.store.dispatch(new SetResearchBase(payload));

        this.store
          .select(stateGetter("researchBaseObj", "gridFilters"))
          .subscribe((data: GetResearchDocsParams) => {
            this.currentGridFilter = data;
            this.getResearchGridData(data);
          });

        //get analyst data and broker data
        this.getAnalystAndBroker();
      },
      (error) => {
        this.hasError = true;
        this.errorMsg =
          "Please contact your account manager for research activation.";
        throw Error(error);
      },
    );
  }

  getAnalystAndBroker() {
    this.service
      .getAnalystList(this.companySymbologyId)
      .subscribe((response) => {
        this.analystData.list = response.map((item) => {
          return {
            label: `${item.display_name} - (${item.publisher_shortname})`,
            value: item.research_analystid,
            checked: false,
          };
        });

        this.analystDataSet = true;
      });
    this.service
      .getBrokerList(this.companySymbologyId)
      .subscribe((response) => {
        this.brokerData.list = response.map((item) => {
          return {
            label: item.publisher_org_name,
            value: item.publisher_org_id,
            checked: false,
          };
        });
        this.brokerDataSet = true;
      });
  }

  getResearchGridData(jsonToPass) {
    if (!this.processedData) {
      this.dataSet = false;
    }
    this.loadingDocuments = true;
    this.service.getDocumentsCall(jsonToPass).subscribe(
      (data) => {
        if (data.status === "error") {
          if (this.isFirstLoad) {
            this.hasError = true;
            this.errorMsg = data.message;
            this.loadingDocuments = false;
            return;
          }

          this.isFirstLoad = false;
          data.docs = [];
        }
        this.isFirstLoad = false;

        this.processedData = data.docs.map((val) => {
          const brokerMappedObj = this.brokerMapping[val.publisher.id];
          const brokerObj = {
            name: brokerMappedObj
              ? brokerMappedObj.bfullname
              : val.publisher.broker_name,
            url:
              brokerMappedObj && brokerMappedObj.entitled
                ? `/reporting/broker/${brokerMappedObj.bn}`
                : "",
            shortName: brokerMappedObj
              ? brokerMappedObj.bn
              : val.publisher.broker_shortname,
          };

          const tempObj = {
            analysts: val.analysts,
            publisher: {
              url: brokerObj.url,
              displayText: brokerObj.name,
              name: brokerObj.shortName,
            },
            title: {
              url: `/research_document/${val.id}/${this.ticker}`,
              target: "new",
              displayText: val.title,
              ticker: this.ticker,
            },
            downloadable: {
              show: val.downloadable,
              data: {
                publicationDate: val.publication_date,
                ticker: this.ticker,
                pageCount: val.page_count,
                displayText: val.title,
                brokerShortName: brokerObj.shortName,
                id: val.id,
                companyId: this.companySymbologyId,
                type: val.mime_type,
                enableWatermark: val.publisher.enable_watermark,
              },
              url: "",
            },
            printable: {
              show: val.printable,
              url: "",
              type: val.mime_type,
              ticker: this.ticker,
            },
            id: val.id,
            pageCount: val.page_count,
            publicationDate: val.publication_date,
            selectionDisabled: !val.downloadable,
          };
          return tempObj;
        });
        this.totalResultCount = data.total_doc_count;
        this.dataToUse = {
          showCheckbox: true,
          showCheckboxHeader: true,
          columnsData: this.columnsData,
          fields: this.columnFields,
          processedData: this.processedData,
          selectedRows: this.selectedRows,
          totalCount: this.totalResultCount,
          widthConfig: [
            "150px",
            "250px",
            "200px",
            "auto",
            "80px",
            "50px",
            "50px",
          ],
          gridHeight: "calc(100vh - 416px)", // height calculated as per screen height - top
          bordered: false,
          count: this.totalResultCount,
          pageIndex: this.currentGridFilter.page,
          showTotalCount: false,
        };
        this.hasError = false;
        this.dataSet = true;
        this.loadingDocuments = false;
      },
      () => {
        this.loadingDocuments = false;
        this.hasError = true;
        this.errorMsg = "Sorry, something went wrong.";
      },
    );
  }

  primaryTickerSwitchChange() {
    setTimeout(() => {
      const payload = {
        ...this.currentGridFilter,
        primaryCo: this.isPrimayTicker ? 1 : -1,
        page: 1,
      };
      this.store.dispatch(new ChangeFilter(payload));
    }, 100);
  }

  analystChange(selectedAnalysts) {
    if (
      !this.currentGridFilter["analystEmailId"] &&
      selectedAnalysts.length === 0
    ) {
      return;
    }
    if (
      JSON.stringify(selectedAnalysts) ===
      JSON.stringify(this.currentGridFilter["analystEmailId"])
    ) {
      return;
    }
    const payload = {
      ...this.currentGridFilter,
      analystId: selectedAnalysts.map((analyst) => {
        return parseInt(analyst, 10);
      }),
      page: 1,
    };
    this.store.dispatch(new ChangeFilter(payload));
  }

  brokerChange(selectedBrokerIds) {
    if (
      !this.currentGridFilter["publisherIds"] &&
      selectedBrokerIds.length === 0
    ) {
      return;
    }
    if (
      JSON.stringify(selectedBrokerIds) ===
      JSON.stringify(this.currentGridFilter["publisherIds"])
    ) {
      return;
    }
    const payload = {
      ...this.currentGridFilter,
      publisherIds: selectedBrokerIds,
      page: 1,
    };
    this.store.dispatch(new ChangeFilter(payload));
  }

  getPageData(page) {
    const payload = {
      ...this.currentGridFilter,
      page: page,
    };
    this.store.dispatch(new ChangeFilter(payload));
  }

  resetAll() {
    const payload = {
      companyId: [this.companySymbologyId],
    };
    this.analystData = {
      ...this.analystData,
      list: this.analystData.list.map((elem) => {
        elem.checked = false;
        return elem;
      }),
    };
    this.brokerData = {
      ...this.brokerData,
      list: this.brokerData.list.map((elem) => {
        elem.checked = false;
        return elem;
      }),
    };
    this.isPrimayTicker = true;

    this.store.dispatch(new ResetFilter(payload));
    this.onResetSubject.next();
    //this.checkRowsSubject.next([]);
  }

  getNextPageData(pageIndex: number, pageSize: number) {
    const payload = {
      ...this.currentGridFilter,
      page: pageIndex,
      pageSize: pageSize,
    };
    this.store.dispatch(new ChangeFilter(payload));
  }

  getSelectedRows(selectedRows: Array<any>) {
    this.selectedRows = selectedRows;
    this.resetSelection = false;
  }

  onClickCancel() {
    this.resetSelection = true;
  }

  onSortChange(sortData: Dictionary<string>) {
    const payload = {
      ...this.currentGridFilter,
      sortBy: sortData.key,
      sortOrder: sortData.value === "ascend" ? "asc" : "dsc",
    };
    this.store.dispatch(new ChangeFilter(payload));
  }

  downloadAll(event: any) {
    const docDetails = [];
    this.selectedRows.forEach((row) => {
      const doc = {
        publication_date: row.publicationDate,
        ticker: this.ticker,
        page_count: row.pageCount,
        title: row.title.displayText,
        broker_short_name: row.publisher.name,
        document_id: row.id,
        enable_watermark:
          row.downloadable && row.downloadable.data
            ? row.downloadable.data.enableWatermark
            : 0,
      };
      docDetails.push(doc);
    });
    this.selectedDownloadItems = {
      companyId: this.vaCompanyId,
      documentDetails: docDetails,
    };

    this.service.getBulkDownload(this.selectedDownloadItems).subscribe(() => {
      // console.log(`api response : ${JSON.stringify(res)}`);
    });
    const extras = {
      beginning_state_referrer: "Dedicated_Research_Page",
      document_count: docDetails.length,
    };
    this.appService.logUserAction(
      event,
      this.ticker,
      "",
      "Research_BulkDownload_From_DedicatedPage",
      extras,
      "",
      "",
    );

    // console.log(`doc details created: ${JSON.stringify(this.selectedDownloadItems)}`);
  }
}
